import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  name: "xpage-search-results",
  class: "search-page-search-results"
}
const _hoisted_2 = {
  name: "xpage-search-results-data",
  class: "search-page-search-results-data"
}
const _hoisted_3 = ["href", "onClick"]

import { ref, watch, computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import SearchPageSearchResult from "@/components/v2/search-page/SearchPageSearchResult.vue";
import SearchPageSearchResultsTable from "@/components/v2/search-page/SearchPageSearchResultsTable.vue";
import SearchPageSearchResultsHeader from "@/components/v2/search-page/SearchPageSearchResultsHeader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResults',
  props: {
  pageName: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

const searchResults = ref<
  CertificationSearchResultModel[] | DisbursementSearchResultModel[]
>([]);

const isLoading = computed<boolean>(
  () => searchPageStore.searchPageState.loading
);

function handleSearchPageResultCardClick(
  result: CertificationSearchResultModel | DisbursementSearchResultModel
) {
  searchPageStore.handleSearchResultClick(result, props.pageName);
}


function getResultUrl(result: CertificationSearchResultModel | DisbursementSearchResultModel) {
  const page = props.pageName;
  const id = searchPageStore.getRouteIdentifier(page,result);
  return `/${page}/${id}`;
}

watch(
  () => searchPageStore.searchPageState.searchResults.data,
  (newValue) => {
    searchResults.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchPageSearchResultsHeader, { sticky: true }),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _withDirectives(_createVNode(SearchPageSearchResultsTable, {
        results: searchResults.value,
        freezeHeaderRow: _unref(searchPageStore).searchPageState.layout === 'table',
        showHeaders: false
      }, null, 8, ["results", "freezeHeaderRow"]), [
        [_vShow, 
          searchResults.value &&
          searchResults.value.length > 0 &&
          !isLoading.value &&
          _unref(searchPageStore).searchPageState.layout !== 'boxes'
        ]
      ]),
      (
          searchResults.value.length > 0 &&
          !isLoading.value &&
          _unref(searchPageStore).searchPageState.layout === 'boxes'
        )
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['x' + _unref(searchPageStore).searchPageState.layout])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (result) => {
              return (_openBlock(), _createElementBlock("a", {
                key: result.id,
                class: "xrow",
                href: getResultUrl(result),
                onClick: _withModifiers(($event: any) => (handleSearchPageResultCardClick(result)), ["prevent"])
              }, [
                _createVNode(SearchPageSearchResult, {
                  result: result,
                  pageName: __props.pageName
                }, null, 8, ["result", "pageName"])
              ], 8, _hoisted_3))
            }), 128))
          ], 2)), [
            [_directive_auto_animate, { duration: 100, ..._ctx.$animate }]
          ])
        : _createCommentVNode("", true)
    ])), [
      [_directive_auto_animate, { duration: 100, ..._ctx.$animate }]
    ])
  ]))
}
}

})